import {Concept} from 'types';
import type {Column, ViewMode} from '../types';

export const filterColumnsByType = (
  allColumns: Column[],
  type: ViewMode,
  columns?: string[],
): string[] => {
  if (type === Concept.work) {
    const filteredColumns = (columns ?? []).filter(
      column => allColumns.find(a => a.name === column)?.workColumn,
    );
    return Array.isArray(filteredColumns) && filteredColumns.length > 0
      ? filteredColumns
      : ['workId'];
  } else {
    return Array.isArray(columns) && columns.length > 0 ? columns : ['ean'];
  }
};
